import React, { useEffect } from 'react'
import { GetServerSideProps, GetServerSidePropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import getConfig from 'next/config'

import { useGetSessionForGetStartedPage } from '@web-apps/feature-auth'
import { ErrorCodes } from '@web-apps/utils-types'
import { Localisation } from '@web-apps/utils-shared'

import { Error } from '../../src/sections/Error'
import { GetStartedPage } from '../../src/containers/GetStartedPage/GetStartedPage'
import { PageWrapper } from '../../src/layouts'

const { i18n } = require('../../next-i18next.config')

const StyledPageWrapper = styled(PageWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const GetStarted = ({
  language,
  error,
}: {
  language: string
  error: ErrorCodes
}) => {
  const { session } = useGetSessionForGetStartedPage()
  const { t } = useTranslation(['pages', 'creator'])

  useEffect(() => {
    if (session) {
      const { publicRuntimeConfig } = getConfig()
      window.location.href = publicRuntimeConfig.baseUrls.creatorApp
    }
  }, [session])

  if (error) return <Error error={error} />

  return (
    <StyledPageWrapper
      language={language}
      seo={{
        title: t('pages:get_started.meta_title'),
        description: t('pages:get_started.meta_description'),
      }}
      fullWidth
      footerSettings={false}
    >
      <GetStartedPage />
    </StyledPageWrapper>
  )
}

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const language = Localisation.DEFAULT_LANGUAGE

  const localisation = await serverSideTranslations(
    language,
    ['app', 'pages', 'creator', 'common'],
    {
      i18n,
    }
  )

  return {
    props: {
      ...localisation,
    },
  }
}

export default GetStarted
